'use client';

import React from 'react';
import { getPageSection, PageSections } from '@/pageBuilder';

const Membership = ({ data, stripeLink }: { data: any[], stripeLink: string }) => (
  <>
    {data.map((section: any) => (
      <React.Fragment key={section.__component + section.id}>
        {getPageSection({
          name: section.__component as PageSections,
          props: {
            data: section,
            ...(section.__component === 'membership.introductory-offer-section' ? { stripeLink } : {}),
            ...(section.__component === 'shared.how-it-works-section' ? { isMembership: true } : {}),
            ...(section.__component === 'shared.faq-section' ? { isMembership: true } : {}),
          },
        })}
      </React.Fragment>
    ))}
  </>
);

export default Membership;
